<div class="tw-p-8 sm-max:tw-p-4 tw-bg-bosch-white">
  <ng-content select="[card-header]"></ng-content>
  <p class="tw-mt-0 tw-mb-4 tw-text-bosch-l tw-font-strong empty:tw-hidden">
    <ng-content select="[card-title]"></ng-content>
  </p>
  <ng-content select="[card-content]"></ng-content>
  <ng-content select="[card-footer]"></ng-content>
</div>
